import { countFoldersRecursively } from './countFoldersRecursively';

export const getActionDisplayText = (action) => {
  const { action_code, action_description } = action || {};
  const body = action_description?.body || {};

  switch (action_code) {
    case 'ACT_SEND_SECURE_MESSAGE':
      return `Subject: ${body.data?.body?.subject || 'No subject'}`;
    case 'ACT_EVENT_CREATE':
      return `Event Title: ${body?.title || 'No title'}`;
    case 'ACT_TASK_CREATE':
      return `Task Name: ${body?.task_name || 'No task name'}`;
    case 'ACT_SEND_TEXT_MESSAGE':
      return `Message: ${body?.message_body || 'No message'}`;
    case 'ACT_CREATE_DOCUMENT':
      return `Document Name: ${body?.document_name || 'No document name'}`;
    case 'ACT_SHARE_FORM':
      return `Form Name: ${body?.form_name || 'No form name'}`;
    case 'ACT_BULK_UPLOAD_FOLDER':
      const folderCount = countFoldersRecursively(body?.folder_tree);
      return `${folderCount} Folders Total`;
    case 'ACT_SEND_EMAIL':
      return `Subject: ${body?.subject || 'No subject'}`;
    default:
      return 'No description available';
  }
};
